/* ============
 * vuex-persistedstate
 * ============
 *
 * Persist Vuex state with localStorage. https://github.com/robinvdvleuten/vuex-persistedstate
 *
 */
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

export const vuexUser = createPersistedState({
    key: 'user',
    paths: [
        'user.userInfo'
    ]
})/*
export const vuexReport = createPersistedState({
    key: 'report',
    paths: [
        // 'reportMappa.segnalazioni',
    ]
})*/
export const vuexToken = createPersistedState({
    key: 'token_id',
    paths: ['auth.token_id'],
    storage: {
        getItem: (key: any) => Cookies.get(key),
        setItem: (key: any, value: any) => Cookies.set(key, value, {
            domain: `.${window.location.hostname}`,
            expires: 375
        }),
        removeItem: (key: any) => Cookies.remove(key)
    }
})
